import styled from "styled-components";
import Div from "../division";

const selectStyleOnlyProps = new Set(["show"]);
const shouldForwardSelectProp = prop => !selectStyleOnlyProps.has(prop);

export const DivWrapper = styled(Div).withConfig({
  shouldForwardProp: shouldForwardSelectProp,
})`
  display: ${props => (props.show ? "block" : "none")};
  position: absolute;
  z-index: 2;
  text-align: left;
  top: 40px;
  background-color: ${props => props.theme.brandWhite};
  color: ${props => props.theme.textGrey};
  border: 1px solid ${props => props.theme.borderBottom};
  padding: ${props => props.theme.padding12};
  overflow-y: auto;
  max-height: 500%;
  > div {
    cursor: pointer;
    padding: ${props => props.theme.padding12};
    border-bottom: 1px solid ${props => props.theme.greyLight};
    transition: background-color 0.2s;
  &:hover {
    background-color: ${props => props.theme.greyLight};
  }
}
  > div:last-child {
    border-bottom: none;
  }
`;
